import { api } from 'shared/api'
import { settingsApiSchemas } from 'shared/api/requests/settings/schemas'
import { _smsSettingsApiSchemas } from 'shared/api/requests/settings/sms/schemas'

import { emailsSchemas } from './email/schemas'
import { statsSchemas } from './stats/schemas'

export const settingsApi = {
  fetchSettings: api.account.createGet({
    url: '/settings/data',
    schemas: settingsApiSchemas.fetchSettings,
  }),
  changeAutomationPauseInitTime: api.account.createPost({
    url: '/settings/changeAutomationPauseSeconds',
    schemas: settingsApiSchemas.changeAutomationPauseInitTime,
    scope: 'livechat',
    section: 'pause_automation',
  }),
  removeNotification: api.account.createGet({
    url: '/settings/removeNotification',
    schemas: settingsApiSchemas.removeNotification,
  }),
  getPageExtendedData: api.account.createGet({
    url: '/settings/pageExtendedData',
    schemas: settingsApiSchemas.getPageExtendedData,
  }),
  readAllPolicyEnforcementNotifications: api.account.createPost({
    url: '/settings/readAllPolicyEnforcementNotifications',
    schemas: settingsApiSchemas.readAllPolicyEnforcementNotifications,
  }),
  general: {
    setUrlShortener: api.account.createPost({
      url: '/settings/setUrlShortener',
      schemas: settingsApiSchemas.setUrlShortener,
    }),
    setBodyUrlShortener: api.account.createPost({
      url: '/settings/setBodyUrlShortener',
      schemas: settingsApiSchemas.setBodyUrlShortener,
    }),
    setPageName: api.account.createPost({
      url: '/settings/setPageName',
      schemas: settingsApiSchemas.setPageName,
    }),
    getListTimezones: api.account.createGet({
      url: '/settings/getListTimezones',
      schemas: settingsApiSchemas.getListTimezones,
    }),
    setTimezone: api.account.createPost({
      url: '/settings/setTimezone',
      schemas: settingsApiSchemas.setTimezone,
    }),
    getMessagingFeatureReview: api.account.createGet({
      url: '/settings/messagingFeatureReview',
      schemas: settingsApiSchemas.getMessagingFeatureReview,
      scope: 'facebook',
    }),
  },
  display: {
    setSkipQuickCampaignsModal: api.account.createPost({
      url: '/settings/setSkipFlowTemplatesModal',
      schemas: settingsApiSchemas.setSkipQuickCampaignsModal,
    }),
    setAudienceOnlyActive: api.account.createPost({
      url: '/settings/setAudienceOnlyActive',
      schemas: settingsApiSchemas.setAudienceOnlyActive,
    }),
  },
  liveChat: {
    setGate: api.account.createPost({
      url: '/settings/changeGate',
      schemas: settingsApiSchemas.setGate,
    }),
    changeLcThreadsFilter: api.account.createPost({
      url: '/settings/changeLcThreadsFilter',
      schemas: settingsApiSchemas.changeLcThreadsFilter,
    }),
    setLivechatSettings: api.account.createPost({
      url: '/settings/setLivechatSettings',
      schemas: settingsApiSchemas.setLivechatSettings,
    }),
    updateLivechatAccountSettings: api.account.createPost({
      url: '/settings/setLivechatAccountSettings',
      schemas: settingsApiSchemas.updateLivechatAccountSettings,
    }),
  },
  notifications: {
    setNotificationEmail: api.account.createPost({
      url: '/settings/setNotificationEmail',
      schemas: settingsApiSchemas.setNotificationEmail,
    }),
    setNotificationPhone: api.account.createPost({
      url: '/settings/setNotificationPhone',
      schemas: settingsApiSchemas.setNotificationPhone,
    }),
    resendConfirmationNotificationEmail: api.account.createPost({
      url: '/settings/resendConfirmationNotificationEmail',
      schemas: settingsApiSchemas.resendConfirmationNotificationEmail,
    }),
    resetUnverifiedNotificationEmail: api.account.createPost({
      url: '/settings/resetUnverifiedNotificationEmail',
      schemas: settingsApiSchemas.resetUnverifiedNotificationEmail,
    }),
    setNotifyAdmin: api.account.createPost({
      url: '/settings/setNotifyAdmin',
      schemas: settingsApiSchemas.setNotifyAdmin,
    }),
    setMobileNotifyAdminPushEnabled: api.account.createPost({
      url: '/settings/setMobileNotifyAdminPushEnabled',
      schemas: settingsApiSchemas.setMobileNotifyAdminPushEnabled,
    }),
  },
  sms: {
    connectSmsByTwilio: api.account.createPost({
      url: '/settings/connectSmsByTwilio',
      schemas: _smsSettingsApiSchemas.connectSmsByTwilio,
    }),
    disconnectSmsByTwilio: api.account.createPost({
      url: '/settings/disconnectSmsByTwilio',
      schemas: _smsSettingsApiSchemas.disconnectSmsByTwilio,
    }),
    enableChannel: api.account.createPost({
      url: '/settings/connectSmsChannel',
      schemas: _smsSettingsApiSchemas.enableChannel,
    }),
    disableChannel: api.account.createPost({
      url: '/settings/disconnectSmsChannel',
      schemas: _smsSettingsApiSchemas.disableChannel,
    }),
  },
  stats: {
    fetchSmsBillingStats: api.account.createGet({
      url: '/settings/getSmsBillingStats',
      schemas: statsSchemas.fetchSmsBillingStats,
    }),
    fetchEmailBillingStats: api.account.createGet({
      url: '/settings/getEmailBillingStats',
      schemas: statsSchemas.fetchEmailBillingStats,
    }),
  },
  setDisplayPreferences: api.account.createPost({
    url: '/settings/setDisplayPreference',
    schemas: settingsApiSchemas.setDisplayPreferences,
  }),
  toggleInstagramChannel: api.account.createPost({
    url: '/settings/toggleInstagramChannel',
    schemas: settingsApiSchemas.toggleInstagramChannel,
    scope: 'instagram',
  }),
  transferOwnership: api.account.createPost({
    url: '/settings/transferOwnership',
    schemas: settingsApiSchemas.transferOwnership,
  }),
  growthTools: {
    getWhitelistingDomains: api.account.createGet({
      url: '/whitelist/getDomains',
      schemas: settingsApiSchemas.getWhitelistingDomains,
      scope: 'facebook',
    }),
    addWhitelistingDomain: api.account.createPost({
      url: '/whitelist/addDomain',
      schemas: settingsApiSchemas.addWhitelistingDomain,
      scope: 'facebook',
    }),
    deleteWhitelistingDomain: api.account.createPost({
      url: '/whitelist/deleteDomain',
      schemas: settingsApiSchemas.deleteWhitelistingDomain,
      scope: 'facebook',
    }),
  },
  leaveAccount: api.account.createPost({
    url: '/settings/doLeaveAccount',
    schemas: settingsApiSchemas.leaveAccount,
  }),

  conversionsApi: {
    setConversionsApiCreds: api.account.createPost({
      url: '/conversionsApi/setConversionsApiCreds',
      schemas: settingsApiSchemas.setConversionsApiCreds,
      scope: 'capi',
    }),
    disconnectConversionsApiCreds: api.account.createPost({
      url: '/conversionsApi/disconnectConversionsApiCreds',
      schemas: settingsApiSchemas.disconnectConversionsApiCreds,
      scope: 'capi',
    }),
    setAutosendEventsToCapi: api.account.createPost({
      url: '/conversionsApi/setAutosendEventsToCapi',
      schemas: settingsApiSchemas.setAutosendEventsToCapi,
      scope: 'capi',
    }),
    getCapiEventActionValues: api.account.createGet({
      url: '/conversionsApi/getCapiEventActionValues',
      schemas: settingsApiSchemas.getCapiEventActionValues,
      scope: 'capi',
    }),
  },
  threadControl: {
    getThreadRoutingData: api.account.createGet({
      url: '/settings/getThreadRoutingData',
      schemas: settingsApiSchemas.getThreadRoutingData,
      scope: 'livechat',
      section: 'conversation_routing',
    }),
  },

  tiktok: {
    toggleTikTokChannel: api.account.createPost({
      url: '/settings/toggleTikTokChannel',
      schemas: settingsApiSchemas.toggleTikTokChannel,
    }),
  },

  instagram: {
    getConnectedInstagramAccount: api.account.createGet({
      url: '/settings/getConnectedInstagramAccount',
      schemas: settingsApiSchemas.getConnectedInstagramAccount,
      scope: 'instagram',
    }),
  },
  facebook: {
    setGreeting: api.account.createPost({
      url: '/settings/setGreeting',
      schemas: settingsApiSchemas.setGreeting,
      scope: 'facebook',
    }),
    disableUserInput: api.account.createPost({
      url: '/settings/composerInputDisable',
      schemas: settingsApiSchemas.composerInputDisable,
      scope: 'facebook',
    }),
    getFbPermissions: api.account.createGet({
      url: '/settings/fbPagePermissionsChecker',
      schemas: settingsApiSchemas.fbPagePermissionsChecker,
      scope: 'facebook',
    }),
    switchFacebookChannel: api.account.createPost({
      url: '/settings/switchFacebookChannel',
      schemas: settingsApiSchemas.switchFacebookChannel,
      scope: 'facebook',
    }),
  },
  whatsapp: {
    setWhatsAppUrlShortener: api.account.createPost({
      url: '/settings/setWhatsAppUrlShortener',
      schemas: settingsApiSchemas.setWhatsAppUrlShortener,
    }),
  },

  payments: {
    connectStripe: api.account.createPost({
      url: '/settings/connectStripe',
      schemas: settingsApiSchemas.connectStripe,
    }),

    disconnectStripe: api.account.createPost({
      url: '/settings/disconnectStripe',
      schemas: settingsApiSchemas.disconnectStripe,
    }),

    setCurrency: api.account.createPost({
      url: '/settings/setCurrency',
      schemas: settingsApiSchemas.setCurrency,
    }),

    setPaymentNotifySettings: api.account.createPost({
      url: '/settings/setPaymentNotifySettings',
      schemas: settingsApiSchemas.setPaymentNotifySettings,
    }),

    setStripeChargeEmailNotification: api.account.createPost({
      url: '/settings/setStripeChargeEmailNotification',
      schemas: settingsApiSchemas.setStripeChargeEmailNotification,
    }),

    connectPaypal: api.account.createPost({
      url: '/settings/connectPaypal',
      schemas: settingsApiSchemas.connectPaypal,
    }),

    disconnectPaypal: api.account.createPost({
      url: '/settings/disconnectPaypal',
      schemas: settingsApiSchemas.disconnectPaypal,
    }),
    fetchPricingLimitInfo: api.account.createGet({
      url: '/settings/pricingLimitInfo',
      schemas: settingsApiSchemas.fetchPricingLimitInfo,
    }),
  },

  handover: {
    getHandoverReceivers: api.account.createPost({
      url: '/settings/getHandoverReceivers',
      schemas: settingsApiSchemas.getHandoverReceivers,
      scope: 'livechat',
      section: 'conversation_routing',
    }),
    setLiveChatReceiver: api.account.createPost({
      url: '/settings/setLiveChatReceiver',
      schemas: settingsApiSchemas.setLiveChatReceiver,
      scope: 'livechat',
      section: 'conversation_routing',
    }),
  },

  email: {
    switchEmailChannel: api.account.createPost({
      url: '/settings/switchEmailChannel',
      schemas: settingsApiSchemas.switchEmailChannel,
    }),
    setEmailSettings: api.account.createPost({
      url: '/settings/setEmailSettings',
      schemas: settingsApiSchemas.setEmailSettings,
    }),
    showEmailBranding: api.account.createPost({
      url: '/settings/showEmailBranding',
      schemas: settingsApiSchemas.showEmailBranding,
    }),
    getBusinessEmailInfo: api.base.createGet({
      url: '/businessEmail/getBusinessEmailInfo',
      schemas: emailsSchemas.getBusinessEmailInfo,
    }),
    sendVerifyAccountBusinessEmail: api.account.createPost({
      url: '/settings/sendVerifyAccountBusinessEmail',
      schemas: emailsSchemas.sendVerifyAccountBusinessEmail,
    }),
    confirmBusinessEmail: api.base.createPost({
      url: '/businessEmail/confirmBusinessEmail',
      schemas: emailsSchemas.confirmBusinessEmail,
    }),
    removeBusinessEmail: api.account.createPost({
      url: '/settings/removeBusinessEmail',
      schemas: emailsSchemas.removeBusinessEmail,
    }),
    verifyBusinessDomain: api.account.createPost({
      url: '/settings/verifyBusinessDomain',
      schemas: emailsSchemas.verifyBusinessDomain,
    }),
    updateBusinessEmail: api.account.createPost({
      url: '/settings/updateBusinessEmail',
      schemas: emailsSchemas.updateBusinessEmail,
    }),
    addBusinessEmail: api.account.createPost({
      url: '/settings/addBusinessEmail',
      schemas: emailsSchemas.addBusinessEmail,
    }),
    getBusinessEmails: api.account.createGet({
      url: '/settings/getBusinessEmails',
      schemas: emailsSchemas.getBusinessEmails,
    }),
  },

  publicApi: {
    getPublicAPIToken: api.account.createPost({
      url: '/api/token/generate',
      schemas: settingsApiSchemas.getPublicAPIToken,
    }),
    deletePublicAPIToken: api.account.createPost({
      url: '/api/token/delete',
      schemas: settingsApiSchemas.deletePublicAPIToken,
    }),
  },

  persona: {
    usePersona: api.account.createPost({
      url: '/settings/usePersona',
      schemas: settingsApiSchemas.usePersona,
    }),
    setPersonaApiData: api.account.createPost({
      url: '/settings/setPersonaApiData',
      schemas: settingsApiSchemas.setPersonaApiData,
    }),
    uploadMultiple: api.account.createPost({
      url: '/content/uploadMultiple',
      schemas: settingsApiSchemas.uploadMultiple,
    }),
  },

  order: {
    getList: api.account.createGet({
      url: '/order/getOrdersList',
      schemas: settingsApiSchemas.getOrdersList,
    }),
  },

  pixel: {
    getScriptUrl: api.account.createGet({
      url: '/pixelSettings/getScriptUrl',
      schemas: settingsApiSchemas.getPixelScriptUrl,
    }),
  },
}
